/* ============================================================
   TRADIE — Bundle Selector: Visual Tweaks
   Pairs with bundle-selector-redesign.css

   Two things CSS alone can't do because the source markup comes
   from a metaobject/metafield (product.metafields.custom.bundle_options
   or metaobjects.product_bundle_group), which is store-wide live
   data — renaming labels there would change the live site
   immediately, not just this draft theme. Doing it here keeps the
   change scoped to the draft for testing.

   1. Relabels pack titles: "Single" -> "1 Pair", "5 Pack" -> "5 Pairs",
      "7 Pack" -> "7 Pairs", "10 Pack" -> "10 Pairs".
   2. Splits the price text ("$14 ea.") into two styled spans
      ("$14" bold + "/ each" light grey) so the CSS can style them
      differently.
   3. Relabels the "Best Seller" badge to "🔥 Top Seller".

   If you rename the tiers in the metaobject directly later (Content
   → Metaobjects, or the product's bundle_options metafield), delete
   part 1 of this script — the titleMap will just no-op harmlessly
   in the meantime since it only replaces exact matches.

   Re-runs on any DOM change (via MutationObserver): switching colour
   variant re-renders the whole bundle selector from its original
   markup, wiping these tweaks out. applyTweaks() is idempotent — each
   step only matches the untouched original text, so it's a safe no-op
   once already applied — so it's safe to call repeatedly.
   ============================================================ */

function applyTweaks() {
  if (!document.querySelector('.pf-bundle-selector')) return;

  // 1. Relabel pack titles
  var titleMap = {
    'Single': '1 Pair',
    '5 Pack': '5 Pairs',
    '7 Pack': '7 Pairs',
    '10 Pack': '10 Pairs'
  };

  document.querySelectorAll('.pf-bundle-title').forEach(function (el) {
    var text = el.textContent.trim();
    if (titleMap[text]) {
      el.textContent = titleMap[text];
    }
  });

  // 2. Reformat "$14 ea." into "$14" + "/ each" as separate spans,
  // leaving the <strong>Save $X</strong> savings pill untouched.
  document.querySelectorAll('.pf-bundle-price').forEach(function (priceEl) {
    for (var i = 0; i < priceEl.childNodes.length; i++) {
      var node = priceEl.childNodes[i];
      if (node.nodeType === Node.TEXT_NODE && node.textContent.trim()) {
        var match = node.textContent.trim().match(/^(\$[\d,.]+)\s*ea\.?$/i);
        if (match) {
          var wrapper = document.createElement('span');
          wrapper.className = 'pf-price-line';

          var amountSpan = document.createElement('span');
          amountSpan.className = 'pf-price-amount';
          amountSpan.textContent = match[1];

          var eachSpan = document.createElement('span');
          eachSpan.className = 'pf-price-each';
          eachSpan.textContent = '/ each';

          wrapper.appendChild(amountSpan);
          wrapper.appendChild(document.createTextNode(' '));
          wrapper.appendChild(eachSpan);

          priceEl.replaceChild(wrapper, node);
        }
        break; // only the first text node — ignore anything after <strong>
      }
    }
  });

  // 3. Relabel the "Best Seller" badge
  document.querySelectorAll('.pf-bundle-badge').forEach(function (el) {
    if (el.textContent.trim() === 'Best Seller') {
      el.textContent = '🔥 Top Seller';
    }
  });
}

document.addEventListener('DOMContentLoaded', applyTweaks);

var pfBundleTweaksScheduled = false;
var pfBundleTweaksObserver = new MutationObserver(function () {
  if (pfBundleTweaksScheduled) return;
  pfBundleTweaksScheduled = true;
  requestAnimationFrame(function () {
    pfBundleTweaksScheduled = false;
    applyTweaks();
  });
});

document.addEventListener('DOMContentLoaded', function () {
  pfBundleTweaksObserver.observe(document.body, { childList: true, subtree: true });
});
